import React from 'react'
import clsx from 'clsx'
import styles from './UIGamePlayerInfoHeaderPointsPublic.module.scss'

interface UIGamePlayerInfoHeaderPointsPublicProps {
    points: number
    color: string
    shouldUseBlackText?: boolean
}

export const UIGamePlayerInfoHeaderPointsPublic = ({
    points,
    color,
    shouldUseBlackText,
}: UIGamePlayerInfoHeaderPointsPublicProps) => (
    <div className={clsx(styles.container, {[styles.blackText]: shouldUseBlackText})} style={{'--color': color} as React.CSSProperties}>
        <div className={styles.points}>
            {points}
        </div>
    </div>
)
